class CascadeStore {
  prevScroll = null;
}

const cascadeStore = new CascadeStore();

export default cascadeStore;
